import { Icon, Table, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  WIDTH_PROJECTS_COLUMN,
  WIDTH_WEEKDAYS_COLUMN,
  offDayTypesEnum,
} from 'modules/project_management/lib/constants'

export interface ICurrentWeekHeaderInfo {
  date: string
  offDayNames: string[]
  offDayType: offDayTypesEnum
}
interface IHeaderProps {
  canReadLeaves: boolean
  currentWeekHeaderInfo: ICurrentWeekHeaderInfo[]
}

const LeavesInfoHeaderCell = ({
  canReadLeaves,
  day,
}: {
  canReadLeaves: boolean
  day: ICurrentWeekHeaderInfo
}) => {
  const [toggle, setToggle] = useToggle()
  const { date, offDayNames, offDayType } = day

  const tooltipLabel = () => {
    if (offDayType === offDayTypesEnum.timeoffLeave)
      return canReadLeaves ? offDayNames.join(',\n') : i18n.t('time_off.title')
    return offDayNames.join(',\n')
  }

  return (
    <Table.HeadCell
      paddingY="s16"
      paddingX="s6"
      colSpan={WIDTH_WEEKDAYS_COLUMN}
      justifyContent="center"
      width={80}
    >
      <Text size="200" weight="semibold">
        {date}
      </Text>
      {offDayNames.length > 0 && (
        <Tooltip.Alt
          attachment="top center"
          open={toggle}
          toggle={setToggle}
          label={tooltipLabel()}
        >
          <Icon.Medium icon="info-circle-line" color="grey800" />
        </Tooltip.Alt>
      )}
    </Table.HeadCell>
  )
}

const Header = ({ canReadLeaves, currentWeekHeaderInfo }: IHeaderProps) => {
  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell paddingX="s16" width={40} />
        <Table.HeadCell colSpan={WIDTH_PROJECTS_COLUMN} paddingY="s16" width={200}>
          {i18n.t('project_management.my_projects.table.projects_column_header')}
        </Table.HeadCell>
        {currentWeekHeaderInfo.map((day, index: number) => {
          if (day.offDayNames.length > 0)
            return <LeavesInfoHeaderCell key={index} canReadLeaves={canReadLeaves} day={day} />

          return (
            <Table.HeadCell
              paddingY="s16"
              paddingX="s6"
              key={index}
              colSpan={WIDTH_WEEKDAYS_COLUMN}
              justifyContent="center"
              width={80}
            >
              <Text size="200" weight="semibold">
                {day.date}
              </Text>
            </Table.HeadCell>
          )
        })}
      </Table.Row>
    </Table.Head>
  )
}

export default Header
